import { EntityAuditDetailed } from "@modernary/mui/components/audit";
import { NotAuthorized, NotFound, PasswordChanged } from "@modernary/mui/components/common";
import Home from "./views/Home.vue";
// import loginRoutes from "./views/login/loginRoutes";
import { contractRouteNames, default as contractRoutes } from "./views/contract/contractRoutes";
import { grantRouteNames, default as grantRoutes } from "./views/grant/grantRoutes";
import { projectRouteNames, default as projectRoutes } from "./views/project/projectRoutes";
import { accountRouteNames, default as accountRoutes } from "./views/account/accountRoutes";

// Troubleshoot your routes using this - https://paths.esm.dev

export const routeNames = {
  home: "Home",
  notAuthorized: "NotAuthorized",
  passwordChanged: "PasswordChanged",
  contract: {
    ...contractRouteNames,
  },
  grant: {
    ...grantRouteNames,
  },
  project: {
    ...projectRouteNames,
  },
  account: {
    ...accountRouteNames,
  },
};

/** @type {import('vue-router').RouterOptions['routes']} */
export const routes = [
  { path: "/", component: Home, name: routeNames.home, meta: { title: "Home", lookupGroups: ["ProjectStatus"] } },
  {
    path: "/unauthorized",
    component: NotAuthorized,
    name: routeNames.notAuthorized,
    meta: { title: "Not Authorized" },
  },
  {
    path: "/password-changed",
    component: PasswordChanged,
    name: routeNames.passwordChanged,
    meta: { title: "Password Changed" },
  },
  ...contractRoutes,
  ...grantRoutes,
  ...projectRoutes,
  ...accountRoutes,
  // ...loginRoutes,
  { path: "/:path(.*)", component: NotFound },
];
